export default __webpack_public_path__ + "static/font-9a8225338d8ee593203cf64d4725fd36.woff2";